import { render } from "./ForgotPasswordLink.vue?vue&type=template&id=37df9054"
import script from "./ForgotPasswordLink.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__